// @ts-nocheck
/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react'
import { createStructuredSelector } from 'reselect'
import { connect, useSelector } from 'react-redux'
import { compose } from 'redux'
import { useTranslation } from 'react-i18next'
import { renderRole } from 'Constants/functions'

import {
  getUser,
  getIsArtist,
  getIsNewTerm,
  getUserRole,
} from 'Redux/selectors/auth'
import { Roles } from 'Constants/enums'
import { getSpotifyToken } from 'Redux/selectors/spotifyToken'
import { getSpotifyAvatar } from 'Redux/actions/auth'
import { getSpotifyAccessToken } from 'Redux/actions/spotifyTokenActions'
import ConnectToSpotifyModal from 'Containers/ui/ConnectToSpotifyModal'
import ava from 'Shared/img/ava.png'

type TopbarProfileProps = {
  getSpotifyAvatar: (callback: (error: string) => void) => void
  user: {
    first_name: string
    last_name: string
    user_photo_url: string
    role: string
  }
  isArtist: boolean
  userRole: Roles
  getSpotifyAccessToken: (
    isAdmin: boolean,
    callback: (error: string) => void
  ) => void
}

const TopbarProfile: React.FunctionComponent<TopbarProfileProps> = ({
  getSpotifyAvatar,
  user: {
    first_name: firstName,
    last_name: lastName,
    user_photo_url: url,
    role,
  },
  isArtist,
  userRole,
  getSpotifyAccessToken,
}) => {
  const { t } = useTranslation()

  const [isDefaultImage, setIsDefaultImage] = useState(!url)
  const [modal, setModal] = useState(false)
  const [
    isGetSpotifyAvatarRequestSent,
    setIsGetSpotifyAvatarRequestSent,
  ] = useState(false)

  const toggle = () => setModal(!modal)

  useEffect(() => {
    const adminItem = localStorage.getItem('admin')
    const isAdmin: boolean = adminItem ? JSON.parse(adminItem) : false

    if (userRole === Roles.influencer) {
      return
    }

    getSpotifyAccessToken(isAdmin, error => {
      if (error && !isAdmin && !isArtist) {
        setModal(true)
      }
    })
  }, [])

  const onLoadError = () => {
    setIsDefaultImage(true)
    if (!isGetSpotifyAvatarRequestSent) {
      getSpotifyAvatar(error => {
        setIsGetSpotifyAvatarRequestSent(true)
        if (!error) {
          setIsDefaultImage(false)
        }
      })
    }
  }

  return (
    <div className="topbar__profile">
      <ConnectToSpotifyModal
        {...{ modal, toggle }}
        //  modal={modal} toggle={toggle}
      />
      <div className="topbar__avatar">
        <img
          alt="avatar"
          className="topbar__avatar-img"
          src={isDefaultImage ? ava : url}
          onError={onLoadError}
        />
        <div className="topbar-name">
          <p className="topbar__avatar-name" data-cy="topbar__avatar-name-p">
            {firstName} {lastName}
          </p>
          <p className="topbar__role">{renderRole(userRole, t)}</p>
        </div>
      </div>
    </div>
  )
}

const selector = createStructuredSelector({
  user: getUser,
  userRole: getUserRole,
  isArtist: getIsArtist,
  accessToken: getSpotifyToken,
})

const actions = {
  getSpotifyAvatar,
  getSpotifyAccessToken,
}

//  eslint-disable-next-line @typescript-eslint/no-explicit-any
export default compose<any>(connect(selector, actions))(TopbarProfile)
